import { Component, OnInit, TemplateRef, ViewChild, Renderer2 } from '@angular/core';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { UserService } from './../../../services/user.service';
import { kpi, kpidelegate, kpiDelegateUpdate, user, year } from './../../../models/slakpi';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  FileType,
  Filters,
  Formatter,
  Formatters,
  GridOption,
  GridStateChange,
  GridStateType
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SpinnerVisibilityService } from 'ng-http-loader';
import * as Slick from 'slickgrid';
import 'slickgrid/plugins/slick.checkboxselectcolumn';
import { ToasterService } from '../../../toaster.service';
import { UtilityService } from './../../../services/utility.service';
import { Users } from './../../../models/users';
import { AngularSlickgridComponent } from 'angular-slickgrid';
import { ResizeObserver } from '@juggle/resize-observer';
import { DatePipe } from '@angular/common';




@Component({
  selector: 'app-kpi-delegation',
  templateUrl: './kpi-delegation.component.html',
  styleUrls: ['./kpi-delegation.component.css'],
  providers: [DatePipe],
})


export class KpiDelegationComponent implements OnInit {
  private _delegateClickHandler: any = null;   // <— add this at class level
  private _ag: AngularGridInstance | null = null;
  angularGrid!: AngularGridInstance;
  public editDelegateAngularGrid: AngularGridInstance;

  private resizeObserver: ResizeObserver;

  // === Responsive columns cache & flags ===
  private allDelegationCols: Column[] = [];
  private allEditCols: Column[] = [];
  private narrowDelegation = false;
  private narrowEdit = false;


  minDate: string;


  // Data for delegation grid
  userDataset: any[] = [];
  kpiDataset: any[] = [];
  delegationDataset: any[] = [];
  delegateToUserDataset: any[] = [];
  filteredUsers: any[] = [];
  dataSearch: any;
  kpidataSearch: any;
  // Backup copy for filtering
  delegationDataSearch: any[] = [];

  gridDataset: any[] = [];

  // Selected items
  selectedUser: any = null;
  selectedKpis: any[] = [];
  selectedDelegateUser: any = null;

  // Search text
  searchTextKpi: string;
  searchTextDelegate: string;
  delegateDataSearch: any[] = [];

  // Column definitions and grid options
  delegationColumnDefinitions: Column[] = [];
  gridOptions: GridOption = {};

  delegateColumnDefinitions: Column[] = [];
  delegateGridOptions: GridOption = {};
  delegateDataSet: any[] = [];

  // Edit Delegation Grid
  editDelegateColumnDefinitions: Column[] = [];
  editDelegateGridOptions: GridOption = {
    enableCellMenu: true,
    addNewRowCssClass: 'action-pop',
  };
  editDelegateDataSet: any[] = [];

  // UI state
  loading: boolean = false;
  loadingKST: boolean = false;
  noDataImg: string = 'assets/img/no-data-image/np-data10.jpg';
  modalRef: BsModalRef;
  @ViewChild('adddelegation', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('editDelegation', { static: false }) editDelegation: TemplateRef<any>;
  @ViewChild('cancelAllKpiDelegation', { static: false }) cancelAllKpiDelegation: TemplateRef<any>;
  @ViewChild('cancelledAllKpiDelegation', { static: false }) cancelledAllKpiDelegation: TemplateRef<any>;
  @ViewChild('delegateGrid', { static: false }) delegateGrid: AngularSlickgridComponent;
  @ViewChild('delegateModalTemplate', { static: false }) delegateModalTemplate!: TemplateRef<any>;

  public selectedDelegation: any;
  public pageAction: string = 'add';
  // Search text for the grid
  searchText: string = '';
  user: any = {};
  public yearUno?: number = 0;
  public quarterUno?: number = 0;
  public yearData: any;
  public quaterData: any;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  public fromDate?: Date;
  public toDate?: Date;
  public filterYear_default: number = 0;
  public filterQuarter_default: number = 0;
  isAdmin: boolean = false;
  isSlaCoordinator: boolean = false;

  delegationType: string = 'Temporary';
  showDates: boolean = true;
  startDate: string | null = null;
  endDate: string | null = null;
  tempStartDate: string; // ISO date string (e.g., "2023-06-15")
  tempEndDate: string;

  //User Data
  userdata: Users = new Users();
  angularGridInstance: AngularGridInstance;

  //cancel
  public delegationsForCancellation: any = {};
  public kpiDelUnoList: any;
  public kpiAllDel: any;
  public editGridDatas: any = [];
  isDelegationBtnDisable: boolean = false;

  cancelDelLableObj: any = {
    kpiCode: '',
    kpiName: '',
    period: '',
    roleType: '',
    isShowLable: false
  };
  constructor(private restApi: SLAKPIApiService,
    private userService: UserService,
    private spinner: SpinnerVisibilityService,
    private modalService: BsModalService,
    private toaster: ToasterService,
    public utilityService: UtilityService,
    private renderer: Renderer2, private datePipe: DatePipe
  ) {
    this.user = this.userService.getUserInfo();
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin') ? true : false;
    this.isSlaCoordinator = (this.user.role === 'SLA Coordinator');
    //this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;

    this.minDate = new Date().toISOString().split('T')[0];
  }



  private applyGridWidthStyles(): void {
    // Prefer your specific grid container id; fall back to SlickGrid container
    const container = document.getElementById('slickGridContainer-delegationGrid')
      || document.querySelector('#musherat-grid') as HTMLElement
      || document.querySelector('.angular-slickgrid') as HTMLElement;

    const delegationGrid = document.getElementById('delegationGrid') as HTMLElement;
    if (!container || !delegationGrid) { return; }

    const isNarrow = (container.clientWidth || 0) <= 1190;

    if (isNarrow) {
      this.renderer.addClass(delegationGrid, 'grid-under-1024');
    } else {
      this.renderer.removeClass(delegationGrid, 'grid-under-1024');
    }
  }




  // ==================== RESIZEOBSERVER FUNCTION START ====================

  ngAfterViewInit() {
    // Initialize ResizeObserver after view is ready with minimal delay
    setTimeout(() => {
      this.initializeResizeObserver();
    }, 50); // Reduced from 100ms to 50ms

    this.applyGridWidthStyles();
  }

  private initializeResizeObserver() {
    try {
      // Create ResizeObserver with optimized callback
      this.resizeObserver = new ResizeObserver(() => {
        this.debounceGridResize();
      });

      // Find grid container with fallback options
      const gridContainer = document.querySelector('#musherat-grid') ||
        document.querySelector('.grid-container') ||
        document.querySelector('.angular-slickgrid');

      if (gridContainer) {
        this.resizeObserver.observe(gridContainer);
      } else {
        console.warn('Grid container not found for ResizeObserver');
      }

    } catch (error) {
      console.error('ResizeObserver initialization failed:', error);
    }
  }

  private resizeTimeout: any;



  private debounceGridResize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    this.resizeTimeout = setTimeout(() => {
      // 1) resize layout
      if (this.angularGrid && this.angularGrid.resizerService) {
        this.angularGrid.resizerService.resizeGrid();
      }


      // 2) apply responsive to main delegation grid
      if (this.angularGrid) {
        this.applyResponsiveColumnsFor(this.angularGrid, this.allDelegationCols, 'delegation');
      }

      // 3) apply responsive to edit-delegate grid
      if (this.editDelegateAngularGrid) {
        this.applyResponsiveColumnsFor(this.editDelegateAngularGrid, this.allEditCols, 'edit');
      }

      this.applyGridWidthStyles();
    }, 100);
  }

  private applyResponsiveColumnsFor(
    ag: AngularGridInstance,
    allCols: Column[],
    which: 'delegation' | 'edit'
  ) {
    const grid = ag && ag.slickGrid;
    if (!grid || !allCols || !allCols.length) { return; }

    // prefer container width; fallback to window width
    const container = grid.getContainerNode() as HTMLElement | null;
    const width = (container && container.clientWidth) ? container.clientWidth : window.innerWidth;
    const isNarrow = width <= 720;

    if (which === 'delegation') {
      if (isNarrow === this.narrowDelegation) { return; }
      this.narrowDelegation = isNarrow;
    } else {
      if (isNarrow === this.narrowEdit) { return; }
      this.narrowEdit = isNarrow;
    }

    if (!isNarrow) {
      grid.setColumns(allCols);
      grid.autosizeColumns();   // <— add
      grid.resizeCanvas();      // <— add
      grid.invalidate();
      grid.render();
      return;
    }

    // below 720px: show 1st, 2nd, 3rd, and last (Action)
    var total = allCols.length;

    if (total <= 4) {
      grid.setColumns(allCols);
      grid.invalidate(); grid.render();
      return;
    }

    // explicitly pick first 3 and last
    var c0 = allCols[0];   // Delegated From
    var c1 = allCols[1];   // Delegated To
    var c2 = allCols[2];   // KPI Name
    var last = allCols[total - 1];  // Action

    // assemble compact array (skip duplicates just in case)
    var compact = [];
    function pushIfValid(col) {
      if (!col) return;
      var exists = false;
      for (var i = 0; i < compact.length; i++) {
        if (compact[i].id === col.id) { exists = true; break; }
      }
      if (!exists) compact.push(col);
    }
    pushIfValid(c0);
    pushIfValid(c1);
    pushIfValid(c2);
    pushIfValid(last);

    compact = compact.map(col => ({
      ...col,
      excludeFromHeaderMenu: col.excludeFromHeaderMenu === true ? true : false,
      header: { ...(col.header || {}), menu: (col.header && col.header.menu) ? col.header.menu : {} }
    }));

    grid.setColumns(compact);
    grid.autosizeColumns();  // <— make columns fit the viewport
    grid.resizeCanvas();     // <— sync the viewport/canvas sizes
    grid.invalidate();
    grid.render();


  }



  ngOnDestroy() {
    // Clean up ResizeObserver
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    // Clear any pending resize timeout
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
  }

  // ==================== RESIZEOBSERVER FUNCTION END ====================








  openModalWithClass(template: TemplateRef<any>, modalClass: string = 'gray modal-xl modal-full', data: any = {}, level: any = '', cancel: any = 0) {


    // Auto-select current user if not admin
    const sessionEmail = this.user.username;
    const currentUser = this.userDataset.find(
      (u) => u.userName === sessionEmail
    );
    //if (this.userdata && this.userdata.userUno) {
    //  this.loadUserKpis({ value: this.userdata.userUno });
    //} else
    if (this.user.role == 'User') {
      this.loadUserKpis(currentUser.userUno);
    }

    // Close any existing open modal
    if (this.modalRef) {
      this.modalRef.hide();
    }

    // Open the new modal
    this.modalRef = this.modalService.show(template, {
      class: modalClass,
      backdrop: 'static',
      keyboard: false,
      ignoreBackdropClick: true
    });

    //for cancel purpose
    if (data && data.originalItem) {
      this.delegationsForCancellation = data.originalItem;
      this.kpiAllDel = data
      this.delegationsForCancellation.level = level;

      if (this.kpiAllDel.__treeLevel == 1) {
        this.cancelDelLableObj = {
          kpiCode: this.kpiAllDel.kpiCode,
          kpiName: this.kpiAllDel.kpiName,
          period: this.kpiAllDel.period,
          roleType: this.kpiAllDel.roleType,
          isShowLable: true
        }
      } else if (this.kpiAllDel.__treeLevel == 0 && this.kpiAllDel.kpis && this.kpiAllDel.kpis.length == 1) {
        this.cancelDelLableObj = {
          kpiCode: this.kpiAllDel.kpis[0].KpiCode,
          kpiName: this.kpiAllDel.kpis[0].KpiName,
          period: this.kpiAllDel.kpis[0].Period,
          roleType: this.kpiAllDel.kpis[0].RoleType,
          isShowLable: true
        }
      } else {
        this.cancelDelLableObj = {
          kpiCode: '',
          kpiName: '',
          period: '',
          roleType: '',
          isShowLable: false
        }
      }
    }

    if (cancel == 1) {
      try {
        if (this.kpiAllDel.__treeLevel == 1) {
          let getUno = this.isMatchingKpiCode(this.kpiAllDel);
          this.kpiDelUnoList = getUno.KpiDelUno
        } else {
          const parsed = JSON.parse(this.delegationsForCancellation.kpisJson);
          this.kpiDelUnoList = parsed.map((k: any) => k.KpiDelUno);
          this.kpiDelUnoList = this.kpiDelUnoList.join(',');
        }

        this.revertDelegation()
      } catch (e) {
        ////console.error('Invalid kpisJson:', this.delegationsForCancellation.kpisJson, e);
        this.toaster.show('error', 'Error', 'Invalid kpisJson');
      }
    }
  }

  isMatchingKpiCode(item: any) {
    const kpiCode = item.kpiCode;
    const jsonStr = item && item.originalItem ? item.originalItem.kpisJson : null;

    if (!jsonStr) return false;

    try {
      const parsed = JSON.parse(jsonStr);
      return parsed.find(function (k: any) {
        return k.KpiCode === kpiCode;
      }) || null;
    } catch (e) {
      //console.error('Invalid kpisJson:', e);
      return false;
    }
  }


  ngOnInit(): void {
    this.defineGrid();
    this.loadDelegationData();
    this.loadFilterValues();
    this.initializeDelegateGrid();
    this.editDelegateGrid();
    this.loadUsers();
  }

  initializeDelegateGrid() {

    this.delegateColumnDefinitions = [
      //  { id: '_checkbox_selector', name: '', field: '', excludeFromExport: true, filterable: false, excludeFromHeaderMenu: true, formatter: Formatters.checkmark, minWidth: 30, maxWidth: 30, resizable: false },
      { id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', filterable: false, excludeFromHeaderMenu: true },
      { id: 'kpiName', name: 'KPI Name', field: 'kpiName', sortable: true },
      { id: 'roleType', name: 'Role Type', field: 'roleType', filterable: false, excludeFromHeaderMenu: true },
      { id: 'period', name: 'Period', field: 'period', filterable: false, excludeFromHeaderMenu: true }
    ];

    this.delegateGridOptions = {
      //autoFitColumnsOnFirstLoad: true,
      //enableSorting: true,
      autoHeight: true,
      enableGridMenu: false,
      enableAutoResize: true,
      headerMenu: {
        buttonCssClass: 'no-hover fa fa-filter'
      },
      autoResize: {
        containerId: 'musherat-grid-new',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      headerRowHeight: 33,
      rowHeight: 32.5,
      enableRowSelection: true,
      enableCheckboxSelector: true,
      checkboxSelector: {
        columnIndexPosition: 0,
        hideSelectAllCheckbox: false,
        width: 34,
        cssClass: 'kpi-select',   // <— hook for styling

        // you can override the logic for showing (or not) the expand icon
        // for example, display the expand icon only on every 2nd row
        selectableOverride: (row: number, data: any, grid: any) => (data.isEnableCheckBox == true)
      },
      multiSelect: true,
      rowSelectionOptions: { selectActiveRow: true },
    };
  }

  // Load users from API
  loadUsers() {
    this.spinner.show();
    this.loading = true;

    const inpValue = new user();
    inpValue.tenantUno = this.userService.getUserInfo().tenantUno;
    inpValue.userUno = this.userService.getUserInfo().id;
    inpValue.languageUno = 1033;

    this.restApi.getDelUsers(inpValue).subscribe(
      (data: any) => {
        let usersArray = data as any[];

        // ✅ Apply role-based filtering
        if (this.isAdmin) { // Admin → all users // || this.isSlaCoordinator

          this.userDataset = usersArray;

        } else { // Normal User → only themselves

          this.userDataset = usersArray.filter(
            (u: any) => Number(u.divisionUno) === Number(this.user.divisionUno)
          );

        }

        // ✅ Map and assign datasets
        this.userDataset = this.userDataset.map((u: any) => ({ ...u, id: u.userUno }));
        this.filteredUsers = this.userDataset.slice();
        this.dataSearch = this.userDataset;
        this.delegateDataSearch = this.userDataset;

        // Use same user list for delegate selection
        this.delegateToUserDataset = this.userDataset;
        //this.delegateToUserDataset = usersArray;//Load all division users regardless of role type
        this.delegateToUserDataset = this.delegateToUserDataset.map((u: any) => ({ ...u, id: u.userUno }));
        console.log(this.userDataset, 'Delegate From');
        console.log(this.delegateToUserDataset, 'Delegate To');

        this.spinner.hide();

        // Auto-select current user if not admin
        const sessionEmail = this.user.username;
        const currentUser = this.userDataset.find(
          (u) => u.userName === sessionEmail
        );

        if (currentUser) {
          this.selectedUser = {
            value: currentUser.userUno,
            text: currentUser.displayText || currentUser.userName
          };
          this.userdata.userUno = currentUser.userUno;
          this.userdata.userName = currentUser.userName || currentUser.displayText;

          if (!this.isAdmin) {
            this.loadUserKpis(currentUser.userUno);
          }
        }
      },
      (error: any) => {
        this.loading = false;
        this.spinner.hide();
      }
    );
  }

  /* handleKpiSelection(kpi: any) {
     this.selectedKpis = kpi;
   }*/

  loadUserKpis(selected: any) {
    this.spinner.show();

    let userUno = null;

    if (Array.isArray(selected) && selected.length > 0) {
      userUno = selected[0].value;
    } else if (selected && typeof selected === 'object') {
      userUno = selected.value;
    } else {
      userUno = selected;
    }

    const user = this.userDataset.find(u => u.userUno == userUno);

    if (!user || !user.userUno || !user.userName) {
      ////console.warn('Invalid user selected:', selected);
      this.spinner.hide();
      return;
    }

    this.userdata.userUno = user.userUno;
    this.userdata.userName = (user.userName || '').trim();
    this.loadingKST = true;
    const inpValue = new kpidelegate();
    inpValue.tenantUno = this.userService.getUserInfo().tenantUno;
    inpValue.userUno = this.userService.getUserInfo().id;
    inpValue.year = this.userService.getUserInfo().currentYear;
    inpValue.quarter = this.userService.getUserInfo().currentQuarter;
    inpValue.languageUno = 1033;
    inpValue.condition = 0;
    inpValue.checkUserUno = user.userUno;

    this.restApi.getDelegateKpi(inpValue).subscribe({
      next: (data) => {
        //const uniqueData = uniqBy(data, 'kpiUno');
        //this.kpiDataset = uniqueData.map((kpi: any) => ({ ...kpi, id: kpi.kpiUno }));
        const uniqueData = uniqBy(data, 'kpiTrnUno');
        this.kpiDataset = uniqueData.map((kpi: any) => ({ ...kpi, id: kpi.kpiTrnUno }));
        this.kpidataSearch = this.kpiDataset;
        this.delegateDataSet = this.kpiDataset;
        this.loadingKST = false;
        this.spinner.hide();
      },
      error: (error) => {
        //console.error('Error loading KPIs', error);
        this.loadingKST = false;
        this.spinner.hide();
      }
    });
  }



  //onDelegateGridReady(angularGrid: AngularGridInstance) {

  //  //debugger;
  //  this.angularGridInstance = angularGrid;  // Keep this as AngularGridInstance
  //  const grid = this.angularGridInstance.slickGrid;

  //  const RowSelectionModel = (window as any).Slick && (window as any).Slick.RowSelectionModel;
  //  if (RowSelectionModel) {
  //    grid.setSelectionModel(new RowSelectionModel({ selectActiveRow: false }));
  //  } else {
  //    ////console.error("Slick.RowSelectionModel is not available. Please ensure SlickGrid scripts are loaded.");
  //  }

  //  grid.onSelectedRowsChanged.subscribe((e, args) => {
  //    const selectedRows = args.rows || [];
  //    this.selectedKpis = selectedRows.map(rowIdx => this.angularGridInstance.dataView.getItem(rowIdx));
  //  });






  //}



  onDelegateGridReady(ag: AngularGridInstance) {
    // keep your reference if you need it elsewhere
    this.angularGridInstance = ag;

    const grid = ag && ag.slickGrid;
    if (!grid) { return; }

    // keep your selection model
    const RowSelectionModel = (window as any).Slick && (window as any).Slick.RowSelectionModel;
    if (RowSelectionModel) {
      grid.setSelectionModel(new RowSelectionModel({ selectActiveRow: false }));
    }

    // keep your selected rows → selectedKpis mapping
    grid.onSelectedRowsChanged.subscribe((e: any, args: any) => {
      const selectedRows = (args && args.rows) ? args.rows : [];
      this.selectedKpis = selectedRows.map((rowIdx: number) =>
        ag.dataView.getItem(rowIdx)
      );
    });





    // === make row click toggle the checkbox ===
    var checkboxPlugin = null;
    if (ag.extensions && ag.extensions.checkboxSelector) {
      checkboxPlugin = ag.extensions.checkboxSelector.instance;
    }

    // avoid duplicate handlers
    if (this._delegateClickHandler) {
      grid.onClick.unsubscribe(this._delegateClickHandler);
    }

    this._delegateClickHandler = (e: any, args: any) => {
      var cols = grid.getColumns();
      var col = cols && cols[args.cell];
      if (col && col.id === '_checkbox_selector') {
        return;
      }

      var row = args.row;

      // skip if checkbox not allowed
      var item = ag.dataView.getItem(row);
      if (item && item.isEnableCheckBox === false) {
        return;
      }

      var selected: number[] = grid.getSelectedRows() || [];
      var isSelected = selected.indexOf(row) > -1;

      if (checkboxPlugin && checkboxPlugin.selectRows && checkboxPlugin.deSelectRows) {
        if (isSelected) {
          checkboxPlugin.deSelectRows([row]);
        } else {
          checkboxPlugin.selectRows([row]);
        }
      } else {
        var isMulti = !!(this.delegateGridOptions && this.delegateGridOptions.multiSelect === true);
        if (isMulti) {
          if (isSelected) {
            var tmp: number[] = [];
            for (var i = 0; i < selected.length; i++) {
              if (selected[i] !== row) tmp.push(selected[i]);
            }
            selected = tmp;
          } else {
            selected = selected.concat(row);
          }
          grid.setSelectedRows(selected);
        } else {
          grid.setSelectedRows(isSelected ? [] : [row]);
        }
      }

      if (e && e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    };

    grid.onClick.subscribe(this._delegateClickHandler);
  }



  onEditing(ag: AngularGridInstance): void {
    this._ag = ag;

    const grid = ag && ag.slickGrid;
    if (!grid) return;



    // get CheckboxSelector plugin instance (if available)
    var checkboxPlugin = null;
    if (ag.extensions && ag.extensions.checkboxSelector) {
      checkboxPlugin = ag.extensions.checkboxSelector.instance;
    }

    // subscribe once – avoid duplicates on re-create
    grid.onClick.unsubscribe();           // clear previous if any
    grid.onClick.subscribe((e: any, args: any) => {
      // which column was clicked?
      var columns = grid.getColumns();
      var col = columns && columns[args.cell];

      // let native checkbox clicks behave normally
      if (col && col.id === '_checkbox_selector') {
        return;
      }

      var row = args.row;

      // Prefer plugin API to keep header "select all" in sync
      if (checkboxPlugin && typeof checkboxPlugin.selectRows === 'function' && typeof checkboxPlugin.deSelectRows === 'function') {
        var selected = grid.getSelectedRows() || [];
        var isSelected = selected.indexOf(row) > -1;

        if (isSelected) {
          checkboxPlugin.deSelectRows([row]);
        } else {
          checkboxPlugin.selectRows([row]);
        }
      } else {
        // Fallback to plain SlickGrid selection (still works)
        var selected2: number[] = grid.getSelectedRows() || [];
        var already = selected2.indexOf(row) > -1;

        var isMulti =
          this.editDelegateGridOptions &&
          this.editDelegateGridOptions.multiSelect === true;

        if (isMulti) {
          if (already) {
            selected2 = selected2.filter(function (r) { return r !== row; });
          } else {
            selected2 = selected2.concat(row);
          }
          grid.setSelectedRows(selected2);
        } else {
          grid.setSelectedRows(already ? [] : [row]);
        }
      }

      // stop any other handlers
      e.stopImmediatePropagation();
    });

    let gridId = null;
    if (ag && ag.slickGrid && ag.slickGrid.getOptions) {
      gridId = ag.slickGrid.getOptions().gridId;

      if (gridId === 'edit-delegate-grid') {
        this.getSelectedEditGridRow(ag)
      }
    }
  }

  onDelegationTypeChange() {
    if (this.delegationType === 'Permanent') {
      this.showDates = false;
      this.tempStartDate = '';
      this.tempEndDate = '';
    } else {
      this.showDates = true;
    }
  }

  // Save delegate details from the modal; update the KPI ownership accordingly
  saveDelegation() {
    if (!this.selectedDelegateUser) {
      this.toaster.show('error', 'Error', 'Please select a delegate user.');
      return;
    }

    if (!this.selectedKpis || this.selectedKpis.length === 0) {
      this.toaster.show('error', 'Error', 'Please select at least one KPI.');
      return;
    }

    let delegateUserUno = '';
    let delegatedUserName = '';

    if (typeof this.selectedDelegateUser === 'object') {
      delegateUserUno = this.selectedDelegateUser.userUno;
      delegatedUserName = this.selectedDelegateUser.displayText || this.selectedDelegateUser.userName || '';
    } else {
      delegateUserUno = this.selectedDelegateUser;
      const matchedUser = this.delegateToUserDataset.find(
        (user: any) => user.userUno === this.selectedDelegateUser
      );
      if (matchedUser) {
        delegatedUserName = matchedUser.displayText || matchedUser.userName || '';
      }
    }

    const currentUserUno = this.userdata.userUno;

    // Get the display name of the user being delegated from
    const fromUserObj = this.delegateToUserDataset.find((user: any) => user.userUno === currentUserUno);
    let delegatedFromUserName = '';
    if (fromUserObj) {
      delegatedFromUserName = fromUserObj.displayText || fromUserObj.userName || '';
    }

    // Validate dates for temporary delegation
    if (this.delegationType === 'Temporary') {
      if (!this.tempStartDate || !this.tempEndDate) {
        this.toaster.show('error', 'Error', 'For Temporary delegation, select Start Date and End Date.');
        return;
      }
      if (new Date(this.tempEndDate) <= new Date(this.tempStartDate)) {
        this.toaster.show('error', 'Error', 'End Date must be after Start Date.');
        return;
      }
    }

    if (this.delegationType === 'Permanent') {
      if (!this.tempStartDate) {
        this.toaster.show('error', 'Error', `Start date are required for ${this.delegationType} delegation`);
        return;
      }
    }
    this.isDelegationBtnDisable = true;
    const delegationList: kpiDelegateUpdate[] = this.selectedKpis.map((kpi: any) => ({
      condition: 1,
      userUno: this.userService.getUserInfo().id,
      currentUserUno: this.userdata.userUno,
      delegatedFromUserName: delegatedFromUserName,
      kpiUno: kpi.kpiUno,
      kpiName: kpi.kpiName,
      kpiCode: kpi.kpiCode,
      roleType: kpi.roleType,
      delegatedUserUno: delegateUserUno,
      delegatedUserName: delegatedUserName,
      delegationType: this.delegationType,
      //startDate: this.delegationType === 'Temporary' ? new Date(this.tempStartDate) : null,
      startDate: new Date(this.tempStartDate),
      endDate: this.delegationType === 'Temporary' ? new Date(this.tempEndDate) : null,
      tenantUno: this.userService.getUserInfo().tenantUno,
      //year: this.userService.getUserInfo().currentYear,
      //quarter: this.userService.getUserInfo().currentQuarter,
      year: kpi.kpiYear,
      quarter: kpi.kpiQuarter,
      openKpiDropdownIndex: -1
    }));


    this.restApi.updateKpiDelegation(delegationList).subscribe(
      (response) => {
        this.toaster.show('success', 'Success', 'User successfully delegated.');
        this.loadDelegationData();
        this.resetAndCloseModal();
        this.modalRef.hide()
        this.isDelegationBtnDisable = false;
      },
      (error) => {
        this.toaster.show('error', 'Error', 'Delegation update failed.');
        //console.error(error);
        this.modalRef.hide();
        this.isDelegationBtnDisable = false;
      }
    );
  }

  resetAndCloseModal() {
    // Reset form state
    this.selectedDelegateUser = null;
    this.selectedUser = null;
    this.selectedKpis = [];
    this.tempStartDate = null;
    this.tempEndDate = null;
    this.delegationType = 'Temporary';
    this.onDelegationTypeChange();

    // Close the modal
    if (this.modalRef) {
      this.modalRef.hide();
    }
    // Clear KPI grid dataset
    this.loadingKST = false;
    if (this.user.role != 'User') {
      this.delegateDataSet = [];
    }
    this.kpidataSearch = [];
  }

  editDelegateGridReady(angularGrid: AngularGridInstance) {
    this.editDelegateAngularGrid = angularGrid;

    // === cache original edit-delegate columns & apply responsive ===
    if (!this.allEditCols.length) {
      this.allEditCols = this.editDelegateColumnDefinitions.slice();

    }
    this.applyResponsiveColumnsFor(this.editDelegateAngularGrid, this.allEditCols, 'edit');
  }


  editDelegateGrid() {
    this.editDelegateColumnDefinitions = [
      { id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', filterable: false, excludeFromHeaderMenu: true },
      { id: 'kpiName', name: 'KPI Name', field: 'kpiName', sortable: true },
      { id: 'roleType', name: 'Role Type', field: 'roleType', filterable: false, excludeFromHeaderMenu: true },
      { id: 'period', name: 'Period', field: 'period', filterable: false, excludeFromHeaderMenu: true }
    ];

    this.editDelegateGridOptions = {
      //autoFitColumnsOnFirstLoad: true,
      headerMenu: {
        buttonCssClass: 'no-hover fa fa-filter',
      },
      enableSorting: true,
      autoHeight: true,
      enableGridMenu: false,
      enableAutoResize: true,
      headerRowHeight: 33,
      rowHeight: 32.5,
      autoResize: {
        containerId: 'edit-delegate-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableRowSelection: true,
      enableCheckboxSelector: true,
      checkboxSelector: {
        columnIndexPosition: 0,
        hideSelectAllCheckbox: false,
        width: 34,
        cssClass: 'kpi-select',   // <— hook for styling
      },
      multiSelect: true,
      rowSelectionOptions: { selectActiveRow: true },

    };
  }

  //openCalendar(event: Event) {
  //  const input = event.target as HTMLInputElement;
  //  if (input.showPicker) {
  //    input.showPicker(); // Chrome/Edge
  //  }
  //};

  //openCustomCalendar(input: any): void {//HTMLInputElement
  //  input.showPicker(); // modern browsers
  //  // fallback for older browsers
  //  input.focus();
  //  input.click();
  //}

  //onDateValue(e: Event) {
  //  const el = e.target as HTMLInputElement;
  //  const v = el.value || null;

  //  if (el.id === 'startDate') {
  //    this.tempStartDate = v;
  //  } else if (el.id === 'endDate') {
  //    this.tempEndDate = v;
  //  }

  //  // if cleared via picker, blur so placeholder shows immediately
  //  if (!v) {
  //    setTimeout(() => el.blur(), 0);
  //  }
  //}


  openCustomCalendar(input: any): void {
    // Samsung Internet sometimes needs a slight delay
    setTimeout(() => {
      try {
        if (input.showPicker) {
          input.showPicker();
        } else {
          // Fallback for older browsers
          input.focus();
          input.click();
        }
      } catch (e) {
        // If showPicker fails, fallback to focus/click
        input.focus();
        input.click();
      }
    }, 10);
  }

  onDateValue(e: Event): void {
    const el = e.target as HTMLInputElement;
    const v = el.value || null;

    if (el.id === 'startDate') {
      this.tempStartDate = v;
    } else if (el.id === 'endDate') {
      this.tempEndDate = v;
    }

    // Force class update for Samsung Internet
    if (v) {
      el.classList.add('has-value');
    } else {
      el.classList.remove('has-value');
    }

    // If cleared, blur to show placeholder
    if (!v) {
      setTimeout(() => {
        el.blur();
        // Force reflow for Samsung Internet
        void el.offsetHeight;
      }, 50); // Increased delay for Samsung devices
    }
  }




  noPastDateValidator(e: Event) {
    const el = e.target as HTMLInputElement;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let selectedDate = new Date(el.value);
    selectedDate.setHours(0, 0, 0, 0);

    if (selectedDate < today) {
      el.value = '';
      if (el.id === 'startDate') {
        this.tempStartDate = '';
      } else if (el.id === 'endDate') {
        this.tempEndDate = '';
      } else if (el.id === 'edStartDate') {
        this.startDate = '';
      } else if (el.id === 'edEndDate') {
        this.endDate = '';
      }
      this.toaster.show('error', 'Error', 'Please select today or a future date.');
    }
    return;
  }

  // Define columns and grid options for the delegation grid
  defineGrid(): void {
    this.delegationColumnDefinitions = [
      {
        id: 'previousUserName',
        name: 'Delegated From',
        field: 'previousUserName',
        filterable: false,
        sortable: true,
        //minWidth:100,
        cssClass: 'cell-title',
        type: FieldType.string,
        //formatter: Formatters.tree, //This adds the expand/collapse icon
        //params: {
        //  treeToggle: true, // enables the icon
        //  collapsedIsDefault: false // set true if you want rows collapsed by default
        //}
        formatter: (row, cell, value, columnDef, dataContext, grid) => {
          const item = grid.getData().getItem(row);
          const isCollapsed = item && item.__collapsed === true;
          const icon = isCollapsed
            ? `<i class="fa fa-angle-right tree-toggle-icon" style="font-size:19px; font-weight:600; color:#000;" aria-hidden="true"></i>`
            : `<i class="fa fa-angle-down tree-toggle-icon"  style="font-size:19px; font-weight:600; color:#000;"  aria-hidden="true"></i>`;
          if (dataContext.__treeLevel == 0) {
            return `
              <span class="slick-group-toggle">${icon}</span>
              <span class="slick-tree-title" level="${dataContext.__treeLevel}">${value}</span>`;
          }
        }
      },
      {
        id: 'delegateUserName',
        name: 'Delegated To',
        field: 'delegateUserName',
        filterable: false,
        sortable: true,
        formatter: (row, cell, value, col, data) => data.__treeLevel === 0 ? `${value}` : ''
      },
      {
        id: 'title',
        name: 'KPI Name',
        field: 'kpiName',
        filterable: false,
        sortable: true,
        type: FieldType.string,
        width: 160,
        maxWidth: 160,
        minWidth: 100,
        formatter: (row, cell, value, columnDef, dataContext, grid) => {
          const item = grid.getData().getItem(row);
          const isCollapsed = item && item.__collapsed !== undefined ? item.__collapsed : false;

          let display = value || '';

          if (dataContext.__treeLevel === 0 && dataContext.kpiCount > 1 && isCollapsed) {
            display += `<span style="font-weight:500;">${dataContext.kpis[0].KpiName} </span><span style="font-weight:500; color: #007560;"> +${dataContext.kpiCount - 1} more</span>`;
          }
          else if (dataContext.__treeLevel === 0 && dataContext.kpiCount == 1 && isCollapsed) {
            display += `<span style="font-weight:500;">${dataContext.kpis[0].KpiName} </span>`;
          }
          return display;
        }
      },
      {
        id: 'kpiCode',
        name: 'KPI Code',
        field: 'kpiCode',
        filterable: false,
        sortable: false,
        excludeFromHeaderMenu: true,
        formatter: (row, cell, value, col, data) => data.__treeLevel === 1 ? value : ''
      },
      {
        id: 'period',
        name: 'Period',
        field: 'period',
        sortable: true,
        formatter: (row, cell, value, col, data) => data.__treeLevel === 1 ? value : ''
      },
      {
        id: 'roleType',
        name: 'Role Type',
        field: 'roleType',
        sortable: true,
        formatter: (row, cell, value, col, data) => data.__treeLevel === 1 ? value : ''
      },
      {
        id: 'delegationType',
        name: 'Delegation Type',
        field: 'delegationType',
        filterable: false,
        excludeFromHeaderMenu: true,
        sortable: true,
        formatter: (row, cell, value, col, data) => data.__treeLevel === 0 ? value : ''
      },
      {
        id: 'startDate',
        name: 'Start Date',
        field: 'startDate',
        //  formatter: Formatters.dateIso,
        sortable: true,
        formatter: (row, cell, value, colDef, data) => {
          if (data.__treeLevel !== 0) return '';
          if (!value || String(value).startsWith('0001')) return '';

          // Parse only the date portion to avoid timezone shifts
          const dateOnlyStr = value.split('T')[0]; // e.g., "2025-07-03"
          const parsedDate = new Date(dateOnlyStr + 'T00:00:00');

          //return parsedDate.toLocaleDateString('en-US', {
          //  year: 'numeric',
          //  month: 'short',
          //  day: 'numeric'
          //});
          const day = String(parsedDate.getDate()).padStart(2, '0');
          const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const year = parsedDate.getFullYear();

          return `${day}-${month}-${year}`; // => "03-07-2025"
        }
      },
      {
        id: 'endDate',
        name: 'End Date',
        field: 'endDate',
        //  formatter: Formatters.dateIso,
        sortable: true,
        formatter: (row, cell, value, colDef, data) => {
          if (data.__treeLevel !== 0) return '';
          if (!value || String(value).startsWith('0001')) return '';

          // Parse only the date portion to avoid timezone shifts
          const dateOnlyStr = value.split('T')[0]; // e.g., "2025-07-03"
          const parsedDate = new Date(dateOnlyStr + 'T00:00:00');

          //return parsedDate.toLocaleDateString('en-US', {
          //  year: 'numeric',
          //  month: 'short',
          //  day: 'numeric'
          //});
          const day = String(parsedDate.getDate()).padStart(2, '0');
          const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
          const year = parsedDate.getFullYear();

          return `${day}-${month}-${year}`; // => "03-07-2025"
        }
      },
      {
        id: 'action',
        name: 'Action',
        field: 'action',
        filterable: false,
        sortable: false,
        excludeFromHeaderMenu: true,
        excludeFromExport: true,
        width: 70, minWidth: 60, maxWidth: 80,
        formatter: () => `<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"
       width="20" height="21" aria-hidden="true" focusable="false"
       style="vertical-align:middle;display:inline-block; cursor: pointer;"
       fill="currentColor">
    <path d="M96 320C96 289.1 121.1 264 152 264C182.9 264 208 289.1 208 320C208 350.9 182.9 376 152 376C121.1 376 96 350.9 96 320zM264 320C264 289.1 289.1 264 320 264C350.9 264 376 289.1 376 320C376 350.9 350.9 376 320 376C289.1 376 264 350.9 264 320zM488 264C518.9 264 544 289.1 544 320C544 350.9 518.9 376 488 376C457.1 376 432 350.9 432 320C432 289.1 457.1 264 488 264z"/>
  </svg>`,
        cellMenu: {
          hideCloseButton: false,

          commandItems: [
            {
              command: 'Edit-row',
              title: 'Edit',
              iconCssClass: 'icon-edit-kpi',
              cssClass: 'green-text  action-pop',
              action: (e, args) => {
                // Capture the selected delegation
                this.selectedDelegation = args.dataContext;
                // Set form data based on the selected delegation
                this.setEditFormData();

                // Open the modal
                this.openModalWithClass(this.editDelegation);
              },
              itemVisibilityOverride: (args) => {
                return args.dataContext && args.dataContext.__treeLevel === 0;
              }
            },
            {
              command: 'Cancel-all-KPI-delegation',
              title: 'Cancel all KPI Delegations',
              iconCssClass: 'icon-cancel-kpi',
              cssClass: 'red-text',
              action: (e, args) => this.openModalWithClass(this.cancelAllKpiDelegation, 'modal-md modal-dialog-centered', args.dataContext, 'parent'),
              itemVisibilityOverride: (args) => {
                return args.dataContext && args.dataContext.__treeLevel === 0;
              }
            },
            {
              command: 'Cancel-KPI-Delegation',
              title: 'Cancel KPI Delegation',
              iconCssClass: 'icon-cancel-kpi',
              cssClass: 'red-text action-pop',
              action: (e, args) => this.openModalWithClass(this.cancelAllKpiDelegation, 'modal-md modal-dialog-centered', args.dataContext, 'child'),
              itemVisibilityOverride: (args) => {
                return args.dataContext && args.dataContext.__treeLevel === 1;
              }
            }
          ]

        }

      }
    ];

    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enableGridMenu: false,
      forceFitColumns: true,
      enableAutoSizeColumns: true,
      enableHeaderMenu: true,
      headerMenu: {
        buttonCssClass: 'no-hover fa fa-filter',
      },
      showHeaderRow: false,   // hiding header row
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      alwaysShowVerticalScroll: false,
      enableFiltering: true,
      enableTreeData: true,
      enableCellMenu: true,
      treeDataOptions: {
        columnId: 'previousUserName',
        parentPropName: 'parentId',
        levelPropName: '__treeLevel',
        indentMarginLeft: 15,
        //initialTreeExpanded: false,
        //collapsedIsDefault: true // collapse is not works 
      },
      multiColumnSort: false,
      headerRowHeight: 0,
      rowHeight: 34,

    };
  }

  parseKpis(kpisJson: string): any[] {
    try {
      return JSON.parse(kpisJson || '[]');
    } catch {
      return [];
    }
  }

  transformToTreeData(data: any[]): any[] {
    const treeData = [];
    for (const delegation of data) {
      const kpis = this.parseKpis(delegation.kpisJson);
      const parentId = delegation.kpiDelUno;
      // Add parent row
      treeData.push({
        id: `parent-${parentId}`,
        kpiName: delegation.kpiName || '', // <- only for KPI name
        kpiCount: kpis.length,             // <- handle count
        previousUserName: delegation.previousUserName,
        delegateUserName: delegation.delegatedUserName,
        delegationType: delegation.delegationType,
        startDate: delegation.startDate,
        endDate: delegation.endDate,
        parentId: null,
        __treeLevel: 0,
        __collapsed: true,
        kpis: kpis,
        originalItem: delegation
      });
      // Add child rows
      for (let i = 0; i < kpis.length; i++) {
        const kpi = kpis[i];
        treeData.push({
          id: `child-${parentId}-${i}`,
          kpiName: kpi.KpiName || '',
          kpiCode: kpi.KpiCode || '',
          period: kpi.Period || '',
          roleType: kpi.RoleType || '---',
          parentId: `parent-${parentId}`,
          __treeLevel: 1,
          originalItem: delegation
        });
      }
    }
    return treeData;
  }

  //new one
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }

  //new one
  setEditFormData(): void {
    if (!this.selectedDelegation) return;

    this.loadingKST = true;
    // Set delegation type and handle dates visibility
    this.delegationType = this.selectedDelegation.delegationType;
    this.showDates = this.delegationType === 'Temporary';

    // Convert dates to proper format for date inputs
    this.startDate = this.selectedDelegation.startDate
      ? this.formatDate(new Date(this.selectedDelegation.startDate))
      : null;

    this.endDate = this.selectedDelegation.endDate
      ? this.formatDate(new Date(this.selectedDelegation.endDate))
      : null;

    // Load KPIs into the edit grid
    if (this.selectedDelegation.kpis && this.selectedDelegation.kpis.length > 0) {
      this.editDelegateDataSet = this.selectedDelegation.kpis.map(kpi => ({
        id: kpi.KpiDelUno,
        kpiCode: kpi.KpiCode,
        kpiName: kpi.KpiName,
        roleType: (kpi.RoleType == '') ? '---' : kpi.RoleType,
        period: kpi.Period,
        kpiYear: kpi.kpiYear,
        kpiQuarter: kpi.kpiQuarter
        //period: this.getPeriodString(this.selectedDelegation)
      }));
      this.setDefaultSelectedDelegate();
    } else {
      this.editDelegateDataSet = [];
    }
    this.loadingKST = false;
  }

  // for loading data in select tag
  setDefaultSelectedDelegate() {
    if (!this.selectedDelegation || !this.delegateToUserDataset.length) {
      return;
    }

    // Case 1: ID (delUserUno) is available
    if (this.selectedDelegation.delUserUno) {
      this.selectedDelegation.delUserName = this.selectedDelegation.delUserUno;

      // ✅ Set displayText based on userUno
      const matchedUser = this.delegateToUserDataset.find(
        user => String(user.userUno) === String(this.selectedDelegation.delUserUno)
      );

      if (matchedUser) {
        this.selectedDelegation.displayText = matchedUser.displayText || matchedUser.userName;
      } else {
        console.warn('No user found for delUserUno:', this.selectedDelegation.delUserUno);
      }

      return;
    }

    // Case 2: fallback to name
    if (this.selectedDelegation.delegateUserName) {
      const matchedUser = this.delegateToUserDataset.find(
        user =>
          user.displayText &&
          user.displayText.trim().toLowerCase() === this.selectedDelegation.delegateUserName.trim().toLowerCase()
      );

      if (matchedUser) {
        this.selectedDelegation.delUserName = matchedUser.userUno;
        this.selectedDelegation.displayText = matchedUser.displayText || matchedUser.userName;

      } else {
        console.warn('No match found for delegateUserName:', this.selectedDelegation.delegateUserName);
      }
    }
  }

  // Helper to format period string
  getPeriodString(delegation: any): string {
    const startDate = delegation.startDate ? new Date(delegation.startDate) : new Date();
    const year = startDate.getFullYear();
    const quarter = Math.floor(startDate.getMonth() / 3) + 1;
    return `${year} - Q${quarter}`;
  }

  assignDefaultFilter() {
    this.filterYear_default = 0;
    this.filterQuarter_default = 0;

    var objFilterItem = this.utilityService.InboxFilter_get();
    if (objFilterItem != null && objFilterItem != undefined) {
      if (objFilterItem.year != 0) {
        this.filterYear_default = objFilterItem.year;
      }
      if (objFilterItem.quater != 0) {
        this.filterQuarter_default = objFilterItem.quater;
      }

    }
  }

  loadFilterValues() {
    this.spinner.show();
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.userService.getUserInfo().id;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {

        let objdata: any = data;
        this.quaterData = objdata.list_QuarterMaster;
        this.yearData = objdata.list_YearMaster;

        setTimeout(() => {
          //if (this.filterSla_default > 0)
          //  setTimeout(() => { this.slaUno = this.filterSla_default; }, 10);
          //if (this.isAdmin)

          this.yearUno = (this.filterYear_default > 0) ? this.filterYear_default : Number(this.currentYear);

          this.quarterUno = (this.filterQuarter_default > 0) ? this.filterQuarter_default : Number(this.currentQuarter);

          //if (this.filterDivision_default > 0)
          //  this.divisionUno = this.filterDivision_default;
          //Load Inbox default value
          //this.loadKPIInbox();
          //this.loadKPIInboxCount();
        }, 230);

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  onchangeYear(e: string | any[]) {

    this.yearUno = (e && e.length > 0) ? e[0].value : 0;
    this.filterYear_default = this.yearUno;
    this.currentYear = this.yearUno;
    this.storeFilterValues();
  }

  onchangeQuarter(e: string | any[]) {
    this.quarterUno = (e && e.length > 0) ? e[0].value : 0;
    this.currentQuarter = this.quarterUno;
    this.filterQuarter_default = this.quarterUno;
    this.storeFilterValues();
  }

  onDateChange(e: any) {
    //this.fromDate = (e && e.length > 0) ? e[0].value : null;
    //this.toDate = (e && e.length > 0) ? e[0].value : null;

  }
  storeFilterValues() {
    this.utilityService.InboxFilter_store(0, 0, this.filterYear_default, this.filterQuarter_default, 0, 0);
  }

  // Simulated data load; replace with your service call if needed

  loadDelegationData(): void {
    this.loading = true;
    const inpValue = new kpiDelegateUpdate();
    inpValue.year = this.userService.getUserInfo().currentYear;
    inpValue.quarter = this.userService.getUserInfo().currentQuarter;
    inpValue.fromDate = this.fromDate;
    inpValue.toDate = this.toDate;
    inpValue.condition = this.isAdmin ? 1 : 2;
    inpValue.tenantUno = this.userService.getUserInfo().tenantUno;
    inpValue.userUno = this.userService.getUserInfo().id;

    this.restApi.getDelegation(inpValue).subscribe(
      (data: any) => {
        this.delegationDataset = this.transformToTreeData(data);
        //new one
        if (this.delegationDataset.length == 0) {
          this.loading = true;
        }
        this.gridDataset = this.delegationDataset;
        this.delegationDataSearch = this.delegationDataset;
        setTimeout(() => {
          if (this.angularGrid && this.angularGrid.treeDataService) {
            this.angularGrid.treeDataService.toggleTreeDataCollapse(true);
          }
        });
        this.loading = false;
      },
      error => {
        //console.error("Error loading delegation data", error);
        this.loading = false;
      }
    );
  }



  // This method is called when the grid is created
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    //setTimeout(() => {
    //  this.angularGrid.resizerService.resizeGrid();
    //  if (this.angularGrid && this.angularGrid.treeDataService) {
    //    this.angularGrid.treeDataService.toggleTreeDataCollapse(true);
    //  }

    //}, 100);




    try {
      const dataView = this.angularGrid.dataView;
      // set getItemMetadata so SlickGrid will add cssClasses to the slick-row
      dataView.getItemMetadata = (rowIndex: number) => {
        const item = dataView.getItem(rowIndex);
        if (item && item.__treeLevel > 0) {
          // this css will be added to the <div class="ui-widget-content slick-row ...">
          return { cssClasses: 'child-row' };
        }
        return null;
      };

      // If grid already rendered, invalidate so metadata is reapplied immediately
      const slickGrid = this.angularGrid.slickGrid;
      if (slickGrid) {
        slickGrid.invalidate();
        slickGrid.render();
      }
    } catch (err) {
      // avoid breaking the app if something unexpected happens
      // console.warn('getItemMetadata hook failed', err);
    }
    // --- END BLOCK ---

    // Initialize ResizeObserver after grid is ready
    setTimeout(() => {
      this.initializeResizeObserver();
    }, 200);

    // === cache original delegation columns & apply responsive ===
    if (!this.allDelegationCols.length) {
      this.allDelegationCols = this.delegationColumnDefinitions.slice();

    }
    this.applyResponsiveColumnsFor(this.angularGrid, this.allDelegationCols, 'delegation');

  }


  // Example action: Export the specific row (or perform any other action)
  exportRow(rowData: any): void {
    // For demonstration, show a toaster message
    this.toaster.show('success', 'Export', `Row with ID ${rowData.id} exported.`);
    // You could also call a service to export that row data to Excel
  }

  // Search function for the delegation grid
  searchGrid(): void {
    if (this.searchText && this.searchText.trim() !== '') {
      const lower = this.searchText.toLowerCase();

      const matchedParentIds = new Set<string>();
      const matchedChildIds = new Set<string>();

      for (const item of this.delegationDataSearch) {
        const isMatch = Object.entries(item)
          .filter(([key, _]) => !key.startsWith('__'))
          .some(([_, value]) =>
            value != null && value.toString().toLowerCase().includes(lower)
          );

        if (isMatch) {
          if (item.__treeLevel === 0) {
            matchedParentIds.add(item.id);
          } else if (item.__treeLevel === 1 && item.parentId) {
            matchedParentIds.add(item.parentId);
            matchedChildIds.add(item.id);
          }
        }
      }

      this.delegationDataset = this.delegationDataSearch.filter(item => {
        if (item.__treeLevel === 0) {
          return matchedParentIds.has(item.id);
        }
        if (item.__treeLevel === 1) {
          return matchedParentIds.has(item.parentId);
        }
        return false;
      });

      setTimeout(() => {
        if (this.angularGrid && this.angularGrid.treeDataService) {
          this.angularGrid.treeDataService.toggleTreeDataCollapse(false);
        }
      });
    } else {
      this.delegationDataset = this.delegationDataSearch;

      setTimeout(() => {
        if (this.angularGrid && this.angularGrid.treeDataService) {
          this.angularGrid.treeDataService.toggleTreeDataCollapse(true);
        }
      });
    }
  }

  // Export to Excel function for the entire grid
  exportToExcel(): void {
    //Open Tree View For Excel Export
    const dataView = this.angularGrid.dataView;
    let items: any = dataView.getItems();
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item && item.__treeLevel == 0) {
        item.__collapsed = false; // open all tree view
        dataView.updateItem(item.id, item); // Update the item in the DataView
      }
    }


    // Implement your export logic here
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,
      });

      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item && item.__treeLevel == 0) {
          item.__collapsed = true; // close all tree view
          dataView.updateItem(item.id, item); // Update the item in the DataView
        }
      }
    }, 100)
    this.toaster.show('success', 'Export', 'Delegation data exported to Excel.');
  }

  getKpiCountFromJson(json: string): number {
    try {
      const parsed = JSON.parse(json || '[]');
      return Array.isArray(parsed) ? parsed.length : 0;
    } catch (e) {
      return 0;
    }
  }

  revertDelegation(): void {
    //const confirmed = window.confirm('Are you sure you want to revert this KPI delegation?');
    //if (!confirmed) {
    //  return; // User canceled
    //}
    const userInfo = this.userService.getUserInfo();
    const obj = new kpiDelegateUpdate()
    obj.tenantUno = userInfo.tenantUno,
      obj.userUno = userInfo.id,
      obj.kpisJson = this.kpiDelUnoList
    //upload: '',
    //actionType: '',
    //icon: '',
    //type: ''
    this.restApi.manualRevertDelegation(obj).subscribe({
      next: (res) => {
        //this.toaster.show('success', 'Revert', 'KPI successfully reverted.');
        this.loadDelegationData();
        if (this.userdata && this.userdata.userUno) {
          this.loadUserKpis({ value: this.userdata.userUno });
        }
      },
      error: (err) => {
        this.toaster.show('error', 'Error', 'Failed to revert KPI.');
      }
    });
  }

  //onEditing(e: AngularGridInstance) {
  //  let gridId = null;
  //  if (e && e.slickGrid && e.slickGrid.getOptions) {
  //    gridId = e.slickGrid.getOptions().gridId;

  //    if (gridId === 'edit-delegate-grid') {
  //      this.getSelectedEditGridRow(e)
  //    }
  //  }
  //}

  getSelectedEditGridRow(gridInstance: AngularGridInstance): any {
    let editGridInstance: any = gridInstance;
    editGridInstance.slickGrid.onSelectedRowsChanged.subscribe((e, args) => {
      const selectedRows = args.rows;
      const selectedData = selectedRows.map(rowIndex => editGridInstance.dataView.getItem(rowIndex));
      this.editGridDatas = selectedData
    });
  }

  selectionChanged(e: any) {
    this.selectedDelegation.delUserUno = e;
  }

  async SaveDelegationEdit(): Promise<void> {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const valEndDate = new Date(this.endDate);
    valEndDate.setHours(0, 0, 0, 0);

    // 1. Validate inputs
    // make shure the delegation is in cap's
    if (this.delegationType === 'Temporary') {
      if (!this.startDate || !this.endDate) {
        this.toaster.show('error', 'Error', 'Start and End dates are required for temporary delegation');
        return;
      }

      if (new Date(this.endDate) <= new Date(this.startDate)) {
        this.toaster.show('error', 'Error', 'End date must be after start date');
        return;
      }

      if (valEndDate < today) {
        this.toaster.show('error', 'Error', 'Start Date and End Date has expired.');
        return;
      }
    }

    if (this.delegationType === 'Permanent') {
      if (!this.startDate) {
        this.toaster.show('error', 'Error', `Start date are required for ${this.delegationType} delegation`);
        return;
      }
    }

    if (!this.selectedDelegation.delUserName) {
      this.toaster.show('error', 'Error', 'Please select a delegate user');
      return;
    }

    // 2. Get selected KPIs from grid
    if (this.editGridDatas.length === 0) {
      this.toaster.show('error', 'Error', 'Please select at least one KPI');
      return;
    }
    this.isDelegationBtnDisable = true;
    // 3. Prepare update payload
    const userInfo = this.userService.getUserInfo();
    this.setDefaultSelectedDelegate();
    const delegationUpdates: kpiDelegateUpdate[] = [];
    const fromUserName = this.selectedDelegation.originalItem.previousUserName;

    for (const kpiItem of this.editGridDatas) {
      delegationUpdates.push({
        condition: 2,
        kpiDelUno: kpiItem.id,
        userUno: userInfo.id,
        currentUserUno: this.selectedDelegation.originalItem.delegatedUserUno,
        delegatedFromUserName: fromUserName,
        kpiUno: kpiItem.kpiUno,
        kpiName: kpiItem.kpiName,
        kpiCode: kpiItem.kpiCode,
        roleType: kpiItem.roleType,
        delegatedUserName: String(this.selectedDelegation.displayText),
        delegatedUserUno: String(this.selectedDelegation.delUserName),
        delegationType: this.capitalizeFirstLetter(this.delegationType),
        //startDate: this.delegationType === 'Temporary' ? new Date(this.startDate) : null,
        startDate: new Date(this.startDate),
        endDate: this.delegationType === 'Temporary' ? new Date(this.endDate) : null,
        tenantUno: userInfo.tenantUno,
        //year: this.userService.getUserInfo().currentYear,
        //quarter: this.userService.getUserInfo().currentQuarter
        year: kpiItem.kpiYear,
        quarter: kpiItem.kpiQuarter
      });

    }
    try {
      this.spinner.show();
      await this.restApi.updateKpiDelegation(delegationUpdates).toPromise();
      this.toaster.show('success', 'Success', 'Delegation updated successfully');
      this.modalRef.hide();
      this.loadDelegationData();
      setTimeout(() => {
        this.isDelegationBtnDisable = false;
      }, 10000); // 10 second
    } catch (error) {
      this.toaster.show('error', 'Error', 'Failed to update delegation');
      this.isDelegationBtnDisable = false;
    } finally {
      this.spinner.hide();
      this.isDelegationBtnDisable = false;
    }
  }

  capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }
}


